import type { ReactNode } from 'react';
import { Button } from '../../catalyst/button';

type Props = {
  onDismiss: () => void;
};

function Key({ children }: { children: ReactNode }) {
  return (
    <kbd className="rounded border border-zinc-300 bg-white px-1 font-mono text-xs dark:border-zinc-600 dark:bg-zinc-900">
      {children}
    </kbd>
  );
}

/** The first-use hint above the canvas: what selecting, groups, focus, and the keys do. */
export function GraphHelp({ onDismiss }: Props) {
  return (
    <div
      role="note"
      className="flex items-center gap-3 border-b border-zinc-200 bg-zinc-50 px-3 py-1.5 text-sm text-zinc-700 dark:border-zinc-700 dark:bg-zinc-800 dark:text-zinc-300"
    >
      <p className="min-w-0 flex-1">
        Click a node to see its details and children · Click a group to open its members · Use Focus to start a new
        view from an engine · <Key>/</Key> search · <Key>c</Key> centre on focus · <Key>f</Key> full screen
      </p>
      <Button plain className="shrink-0" onClick={onDismiss}>
        Got it
      </Button>
    </div>
  );
}
